<template>
  <section v-if="canShowMaintenanceNotice" class="p-2">
    <Banner
      type="is-primary"
      :show-close="canShowClose"
      :is-borderless="true"
      :has-icon="false"
      @on-close="onClose"
    >
      <template #title>
        <p
          class="has-text-black has-text-weight-normal is-size-6"
          v-dompurify-html="$t('core.maintenance-mode')"
        ></p>
      </template>
    </Banner>
  </section>
</template>

<script>
import dayjs from 'dayjs';
import Banner from '/@/modules/core/ui/components/Banner.vue';
import LocalStorage from '@/modules/core/app/helpers/LocalStorage';
import { LocalStorageKey } from '@/modules/core/app/constants/app.constants';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'MaintenanceNoticeBanner',
  components: { Banner },
  props: {
    canShowClose: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    canShowMaintenanceNotice() {
      return (
        dayjs().isBefore(dayjs('2025-02-15 18:00:00')) &&
        LocalStorage.getItem(LocalStorageKey.DISMISSED_MAINTENANCE_BANNER) !== 'true'
      );
    }
  },
  methods: {
    onClose() {
      LocalStorage.setItem(LocalStorageKey.DISMISSED_MAINTENANCE_BANNER, true);
    }
  }
};
</script>

<style scoped>
:deep(.banner.is-borderless > .message > .message-header) {
  border: unset !important;
  background-color: var(--ce-primary-rgba-20) !important;
  border-radius: var(--ce-radius-small) !important;
}
</style>
